/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';

export default function Icon({ title = null }) {
  return (
    <svg role="img" aria-labelledby="phoneIcon" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title id="phoneIcon">{title}</title>}
      <path d="M4.5207 4.5207C4.1873 4.8541 4 5.30628 4 5.77778V6.66667C4 14.0302 9.96978 20 17.3333 20H18.2222C18.6937 20 19.1459 19.8127 19.4793 19.4793C19.8127 19.1459 20 18.6937 20 18.2222V15.3076C20 15.1209 19.9413 14.939 19.8322 14.7876C19.7231 14.6362 19.5691 14.523 19.392 14.464L15.3982 13.1324C15.1953 13.065 14.9748 13.073 14.7772 13.1549C14.5796 13.2369 14.4183 13.3873 14.3227 13.5787L13.3182 15.5849C11.1417 14.6015 9.39851 12.8583 8.41511 10.6818L10.4213 9.67733C10.6127 9.58174 10.7631 9.42036 10.8451 9.2228C10.927 9.02524 10.935 8.80475 10.8676 8.60178L9.536 4.608C9.47707 4.43107 9.36399 4.27716 9.21276 4.16804C9.06153 4.05893 8.87982 4.00014 8.69333 4H5.77778C5.30628 4 4.8541 4.1873 4.5207 4.5207Z" stroke="#585F69" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Icon.propTypes = {
  title: PropTypes.string,
};
